import { useMemo } from "react";
import "../../../style/punchinpuchout.css";

export default function TodayPunchDetails({ empPunchDetails = [] }) {
  const processedPunchDetails = useMemo(() => {
    if (!empPunchDetails.length) return [];

    // 1. Filter out exact duplicates based on punch in and out times
    const uniqueDetails = [];
    const seen = new Set();

    empPunchDetails.forEach(p => {
      // Create a unique key for the punch record
      const key = `${p.punchInTime}_${p.punchOutTime}`;
      if (!seen.has(key)) {
        seen.add(key);
        uniqueDetails.push(p);
      }
    });

    // 2. Sort chronologically by punchInTime (ascending)
    return uniqueDetails.sort((a, b) => {
      const timeA = new Date(a.punchInTime).getTime() || 0;
      const timeB = new Date(b.punchInTime).getTime() || 0;
      return timeA - timeB;
    });
  }, [empPunchDetails]);

  return (
    <div className="card punch-card">
      <div className="d-flex align-items-start gap-3 mb-3">

        {/* Icon */}
        <div className="icon-box bg-primary-light">
          <i className="fas fa-clock text-primary"></i>
        </div>

        {/* Title + Subtitle */}
        <div>
          <h5 className="mb-1 fw-semibold">
            Today's Punch In / Punch Out
          </h5>
          <p className="text-muted small mb-0">
            Track your daily attendance time
          </p>
        </div>

      </div>

      {processedPunchDetails.length === 0 ? (
        <div className="punch-empty">
          <p>No punch data available</p>
        </div>
      ) : (
        <div className="punch-scroll">   {/* ✅ Scroll wrapper OUTSIDE map */}
          <ul className="punch-list">
            {processedPunchDetails.map((p, i) => (
              <li key={i} className="punch-item">
                <div className="punch-row">
                  <span className="label">Punch In</span>
                  <span className="value">
                    {p.punchInTime ? formatTime(p.punchInTime) : "--"}
                  </span>
                </div>

                <div className="punch-row">
                  <span className="label">Punch Out</span>
                  <span className="value">
                    {p.punchOutTime ? formatTime(p.punchOutTime) : "--"}
                  </span>
                </div>


              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}

// ---------- helper ----------
function formatTime(dateStr) {
  const date = new Date(dateStr);
  return date.toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
  });
}
